/*
* fixd Delivery - by Fenix Commerce
* version: 1.0.0
* Confidentiality Notice: This document is confidential. No part of this document shall be disclosed to any 3rd party with prior written approval from Fenix Commerce Inc
* IP Notice: This document is an intellectual property of Fenix Commerce Inc. protected under USPTO laws. Please do not share, edit or modify it in any form, with any one without written consent from Fenix Commerce Inc.
* Author: Nithya Priya Radha Krishnan
* Date: 05/16/2019
* */
(function(){
    var retryAttempts = 0;
    let fixdCssConfig = {
        fontSize: '15px',
        messageHighlightFontWeight:'700',
        messageHighlightColor: '#447d14',
        changeZipTextColor:'#007ace',
        buttonBackgroundColor:'#000',
        buttonTextColor:'#fff',
        buttonFontSize:'15px',
        errorMessageColor:'#ff0000'
    };
    let $tenantId = ``;
    let fenixStoreInfo = {
        delEstUrl: 'https://test.fenixcommerce.com/fenixdelest/api/v2/deliveryestimates'
    };
    let fenixEventHandlersAttached = false;
    let fenixCartEventHandlersAttached = false;
    let fenixAdditionalProcessing = false;
    var fenixInitializedEvent;
    let getFixdDeliveryStyles = function(cssConfig, pageType){
        if(cssConfig && Object.keys(cssConfig).length > 0) {
            for(let key in fixdCssConfig){
                if(key && fixdCssConfig.hasOwnProperty(key) && cssConfig.hasOwnProperty(key) && cssConfig[key]){
                    fixdCssConfig[key] = cssConfig[key];
                }
            }
        }
        let fixdDeliveryPdpCss = `.fenix-fixd-delivery{font-size: ${fixdCssConfig.fontSize};} .fenix-fixd-delivery .message-color-code{color: ${fixdCssConfig.messageHighlightColor};font-weight: ${fixdCssConfig.messageHighlightFontWeight};} .fenix-fixd-delivery .branding-color-code{color: #1D4F84;} .fenix-fixd-delivery #deliveryResponse{ font-size: ${fixdCssConfig.fontSize};} .fenix-fixd-delivery #deliveryResponse span{color: #000;} #fenix-change-zip{margin-top: 5px;} .fenix-fixd-delivery #fenix-change-zip #fenix-toggle-zip{ cursor: pointer;color: ${fixdCssConfig.changeZipTextColor};text-decoration: underline;} #fenix-change-zip #fenix-zip{ display: flex;} #fenix-change-zip #fenix-zip input {padding-bottom: 10px;width: 150px;display:inline} #fenix-change-zip #fenix-zip button{padding: 12px; border: 1px solid #000; margin-left: -1px; background-color: ${fixdCssConfig.buttonBackgroundColor}; color: ${fixdCssConfig.buttonTextColor}; border-radius: 2px; line-height: normal;font-size: ${fixdCssConfig.buttonFontSize};} .fenix-fixd-delivery .zip-input-error{display: none;font-size: 13px;
      color: ${fixdCssConfig.errorMessageColor};}`;
        let fixdDeliveryCartCss = `.fenix-fixd-delivery-cart{font-size: ${fixdCssConfig.fontSize};} .fenix-fixd-delivery-cart .message-color-code{color: ${fixdCssConfig.messageHighlightColor};font-weight: ${fixdCssConfig.messageHighlightFontWeight};} .fenix-fixd-delivery-cart .branding-color-code{color: #1D4F84;} .fenix-fixd-delivery-cart b span{font-weight: 600} #fenix-change-zip{margin-top: 5px;} .fenix-fixd-cart-response #fenix-change-zip #fenix-toggle-zip{ cursor: pointer;color: ${fixdCssConfig.changeZipTextColor};text-decoration: underline;} #fenix-change-zip #fenix-zip{ display: flex;} #fenix-change-zip #fenix-zip input {padding-bottom: 10px;width: 150px;display:inline} #fenix-change-zip #fenix-zip button{padding: 12px; border: 1px solid #000; margin-left: -1px; background-color: ${fixdCssConfig.buttonBackgroundColor}; color: ${fixdCssConfig.buttonTextColor}; border-radius: 2px; line-height: normal;font-size: ${fixdCssConfig.buttonFontSize};} .fenix-fixd-cart-response .zip-input-error{display: none;font-size: 13px;
      color: ${fixdCssConfig.errorMessageColor};}`;
        if(pageType === 'cart') {
            return fixdDeliveryCartCss;
        } else {
            return fixdDeliveryPdpCss;
        }
    };
    let addFixdDeliveryCss = function(fenixMessageStyles){
        let head = document.head || document.getElementsByTagName('head')[0];
        let hasStyles = $(head).find('[data-fenix-style]');
        if(hasStyles.length === 0){
            let style = document.createElement('style');
            head.appendChild(style);
            style.type = 'text/css';
            style.setAttribute('data-fenix-style', true);
            let pageType = 'pdp';
            if(fenixFixdDelivery && fenixFixdDelivery.page && fenixFixdDelivery.page === 'cart'){
                pageType = 'cart'
            }
            let cssConfig = (fenixMessageStyles && Object.keys(fenixMessageStyles).length > 0) ? fenixMessageStyles : undefined;
            let styleClassDef = getFixdDeliveryStyles(cssConfig, pageType);
            if (style.styleSheet){
                // This is required for IE8 and below.
                style.styleSheet.cssText = styleClassDef;
            } else {
                style.appendChild(document.createTextNode(styleClassDef));
            }
        }
    };
    function setupFenixEvents(){
        fenixInitializedEvent = new Event('fenixInitialized');
    }
    function getFixdBrandingLogo(){
        return `<svg width="40" height="12" viewBox="0 0 174 57" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 0H37.9581V11.5932H12.4662V23.1864H36.0402V34.7797H12.4662V57H0V0Z" fill="#1D4F84"/>
<path d="M43.5338 0H56V57H43.5338V0Z" fill="#1D4F84"/>
<path d="M80.9224 27.2119L62.1247 0H77.8698L90 19.9661L101.648 0H116.831L98.4349 26.9703L119 57H103.255L89.3573 34.0551L75.8615 57H61L80.9224 27.2119Z" fill="#24ACCC"/>
<path d="M121 0H139.992C144.592 0 148.947 0.509888 153.06 1.52966C157.226 2.54944 160.851 4.21327 163.936 6.52118C167.02 8.77542 169.455 11.7274 171.24 15.3771C173.08 19.0268 174 23.4548 174 28.661C174 33.2768 173.107 37.3559 171.322 40.8983C169.59 44.387 167.236 47.339 164.26 49.7542C161.284 52.1158 157.848 53.9138 153.953 55.1483C150.057 56.3828 145.971 57 141.697 57H121V0ZM133.662 45.4068H140.236C143.158 45.4068 145.863 45.1116 148.352 44.5212C150.895 43.9308 153.087 42.9647 154.926 41.6229C156.766 40.2274 158.2 38.4294 159.228 36.2288C160.31 33.9746 160.851 31.2373 160.851 28.0169C160.851 25.226 160.31 22.8107 159.228 20.7712C158.2 18.678 156.793 16.9605 155.008 15.6186C153.222 14.2768 151.112 13.2839 148.677 12.6398C146.296 11.9421 143.78 11.5932 141.129 11.5932H133.662V45.4068Z" fill="#1D4F84"/>
</svg>`;
    }
    function isValidUSZip(sZip) {
        return /^\d{5}(-\d{4})?$/.test(sZip);

    }
    function createPhraseForDeliveryEstimate(data={}, pageType) {
        let formattedPhrase = '';
        let message = data.response?data.response : '';
        let chooseShippingMsg = '';
        if(message.indexOf('Today') > -1){
            message = message.replace('Today', '<span class="message-color-code">Today</span>')
        }
        if(data.formattedDeliveryDate){
            let delDatePattern = new RegExp(data.formattedDeliveryDate);
            message = message.replace(delDatePattern, function(phrase){
                return '<span class="message-color-code">' + phrase + '</span>';
            });
        }
        if(data.hours){
            let delHoursPattern = new RegExp(data.hours + ' hours', 'i');
            message = message.replace(delHoursPattern, function(phrase){
                return '<span class="message-color-code">' + phrase + '</span>';
            });
        }
        if(data.minutes){
            let delMinsPattern = new RegExp(data.minutes + ' minutes', 'i');
            message = message.replace(delMinsPattern, function(phrase){
                return '<span class="message-color-code">' + phrase + '</span>';
            });
        }
        if(message.indexOf('Choose') > -1){
            let chooseRegex = new RegExp('\(Choose \)\(.*\)\(?=\)', 'i');
            message = message.replace(chooseRegex, function(phrase){
                chooseShippingMsg = phrase;
                return '';
            });
        }
        if(chooseShippingMsg){
            let chooseShippingRegex = new RegExp('\(Choose \)\(.*\)\(?= shipping \)', 'i');
            chooseShippingMsg = chooseShippingMsg.replace(chooseShippingRegex, function(phrase, g1, g2){
                let formattedName =  '';
                if(fenixStoreInfo && fenixStoreInfo.displayFixdBranding){
                    let method = g2.substr(g2.indexOf('FIXD')+4).trim();
                    formattedName = g1 + '<strong>' + getFixdBrandingLogo() + '&nbsp;<span class="branding-color-code">' + method +'</span></strong>';
                }else{
                    formattedName = g1 + '<strong>' + g2.toUpperCase() + '</strong>';
                }
                return formattedName;
            });
            chooseShippingMsg = chooseShippingMsg + ' to zip: ' + data.buyerZipCode;
            formattedPhrase = message + '<br/>' + chooseShippingMsg;
        } else if(message.length > 0){
            message = message + ' to zip: ' + data.buyerZipCode;
            formattedPhrase = message;
        }
        return formattedPhrase;

    }
  function getPositionCoordinates(callback){
    if (typeof Cookies.get("location") === 'undefined') {
        const ipapiKey = 'cKGC3jQbSIoXYmI2KtXObugsKfosD9Yr0HnkHhPUu1SM2wQhE0';
            $.ajax(`https://ipapi.co/json?key=${ipapiKey}`).then(function success(response) {
                ipLocation = response.postal;
                if (isValidUSZip(ipLocation)) {
                    Cookies.set('location', ipLocation, {
                        path: '/'
                    });
                    if (callback) {
                        callback(ipLocation);
                    }
                } else {
                    console.log('Locating Client Location failed');
                }
            }, function fail(data, status) {
                console.log('Locating Client Location failed');
            });
    }
   }
    let fenix_pdp_estimates = function($){
        let ssid = Cookies.get('__ssid') != null ? Cookies.get('__ssid') : '';
        const fixdDeliveryElement = $('.fenix-fixd-delivery');
        $(fixdDeliveryElement).hide();
        const toggleZipTemplate = `<div id="fenix-zip" style="display: none;">
              <input type='text' id='zip-inpt'/><button type='button' id='check-zip'>Check Delivery</button></div><div class='zip-input-error' >Unable to get estimated delivery date. Please enter a valid US zipcode</div>`;
        let fenixRespTemplate = `<div id="fenix-response"></div><div id="fenix-change-zip" ><a id="fenix-toggle-zip" class="update-zip" style="display: none;">Change ZIP</a>${toggleZipTemplate}</div>`;
        if(fenixFixdDelivery.shippingOptions && fenixFixdDelivery.shippingOptions.showAll){
			fenixRespTemplate = `<div id="fenix-response"></div><div id="fenix-change-zip" ><div class='shipping-options-container'>
                                                            Ship to: <span id="zipcode-holder"></span> <a id="fenix-toggle-zip" class="update-zip" style="display: none;" href="javascript:void(0);">Change</a> <a href="javascript:void(0);" id="view-all-shipping">View All Shipping Options</a>
                                                        </div>${toggleZipTemplate}</div>`;
        }
      	const zipInputElement = $(fixdDeliveryElement).html($(fenixRespTemplate));
        document.dispatchEvent(fenixInitializedEvent);
        const $fenix = $('#fenix');
//         const $qtyField = $("[name=quantity]");
        const $fenixResponse = $('#fenix-response');
        const $fenixZipError = $('#fenix-change-zip .zip-input-error');
        const $zipDiv = $('#fenix-zip');
        const $zipInpt = $('#zip-inpt');
        const $checkZip = $('#check-zip');
        const $toggleZip = $('#fenix-toggle-zip');
        const $shipMessage = $('#current_variant_shipping_message');
        const $ssid = $('#currentUser_sessionid');
        const $productFormStatus=$('.product__form-status');
        const $quantity=$("[name=quantity]");
        let showZipcodeField = !1;
        let zipcode = price = sku = availableqty =
            productid =
                variantid =
                    flag =
                        physical = currentProduct = undefined;
        let locationid = 'manual';
        if(typeof fenixFixdDelivery !== 'undefined' && fenixFixdDelivery && fenixFixdDelivery !== undefined){
            price = (fenixFixdDelivery.productVariant && fenixFixdDelivery.productVariant.price) ? fenixFixdDelivery.productVariant.price : 0;
            variantid = fenixFixdDelivery.productVariant.id;
            sku = fenixFixdDelivery.productVariant.sku;
            availableqty = fenixFixdDelivery.productVariant.inventory_quantity;
            flag = fenixFixdDelivery.productVariant.available;
            physical = fenixFixdDelivery.productVariant.requires_shipping;
            page = fenixFixdDelivery.page || '';
            locationid = fenixFixdDelivery.locationid || 'manual';
            if(fenixFixdDelivery.product !== undefined){
                currentProduct = fenixFixdDelivery.product;
                productid = currentProduct.id;
            }
            getNewShippingEstimatesOnChange();
            checkAdditionalProcessing();
        }
        let showMessage = physical !== undefined ? physical : false;
        zipcode = Cookies.get("location") !== null && isValidUSZip(Cookies.get("location")) ? Cookies.get("location") : fenixFixdDelivery.zipcode;
        function toggleZipField(e) {
            if(e){
                e.stopPropagation();
            }
            showZipcodeField = true;
            $toggleZip.hide();
            $zipDiv.show();
        }

        function getRequestData() {
            let reqObj = {
                "sessionTrackId": ssid,
                "buyerZipCode": "" + zipcode,
                "monetaryValue": (parseInt(price) / 100).toFixed(2),
                "pageType": 'PDP',
                "responseFormat": "json",
                "skus": [{
                    "quantity": parseInt($quantity.val())?parseInt($quantity.val()) : 1,
                    "sku": sku,
                    "skuInventories": [{
                        "locationId": locationid || 'manual', // Fulfilment location id
                        "quantity": availableqty ,
                    }]
                }]
            };
            if(fenixAdditionalProcessing){
                reqObj['additionalProcessing'] = true;
            }
            return reqObj;
        }


        if ((typeof Cookies.get("location") === 'undefined') && showMessage) {
            setTimeout(getLocation, 300);

        } else {
            if (!(zipcode == '')) {
                setTimeout(checkShippingEstimate, 300);
            }
        }


        let onChangeFlag = !0;

        function checkShippingEstimate() {
            $.ajax({
                type: "POST",
                url: fenixStoreInfo.delEstUrl,
                data: JSON.stringify(getRequestData()),
                headers: {
                    'tenantId': $tenantId, // Fenix tenant id. Shared by Fenix team.
                    'Content-Type': 'application/json'
                },
                dataType: "json",
                timeout: 2000
            }).done(function(data) {
                if(data && data.length > 0){
                    let res = data[0];
                  let phrase = '';
                  if(fenixFixdDelivery.shippingOptions && fenixFixdDelivery.shippingOptions.showAll && fenixShowAllShippingOptions && typeof fenixShowAllShippingOptions === 'function'){
                  		phrase = fenixShowAllShippingOptions(data, fenixFixdDelivery.shippingOptions);
                  }else {
                    if(fenixFixdDelivery.createPhraseForDeliveryEstimate && typeof fenixFixdDelivery.createPhraseForDeliveryEstimate === 'function'){
                        phrase = fenixFixdDelivery.createPhraseForDeliveryEstimate(res);
                    } else {
                        phrase = createPhraseForDeliveryEstimate(res, 'PDP');
                    }
                    $fenixResponse.html(phrase);
                  }
                    $('.fenix-fixd-delivery').show();
                    $('.fenix-fixd-delivery').attr('data-fenix-session', ssid);
                    if ($ssid && $ssid.length > 0) {
                        $ssid.val(ssid)
                    }
                    shipMessage = !0;
                    if ($shipMessage) {
                        $shipMessage.val(showMessage);
                    }
                    $fenixResponse.show();
                    if(phrase && phrase.length > 0){
                        $toggleZip.show();
                        $zipDiv.hide();
                        $fenixZipError.hide();
                    }else {
                        toggleZipField();
                        $fenixZipError.show();
                    }
                    if(!fenixEventHandlersAttached){
                        attachAllFenixEventHandlers();
                    }
                }else {
                    $fenixResponse.hide();
                    if(availableqty > 0){
                        $toggleZip.show();
                    }
                }
            }).fail(function(error) {
                $fenixResponse.hide();
                if(availableqty > 0){
                    $toggleZip.show();
                }
            })
        }
        function getEstimateForZip(e){
            if(e) {
                e.stopPropagation();
            }
            if (isValidUSZip($zipInpt.val())) {
                zipcode = $zipInpt.val();
                Cookies.remove('location', {
                    path: '/'
                });
                Cookies.set('location', $zipInpt.val(), {
                    path: '/'
                });
                checkShippingEstimate();
                $toggleZip.show();
                $zipDiv.hide();
                $fenixZipError.hide();
            } else {
                $fenixResponse.hide();
                $toggleZip.hide();
                $zipDiv.show();
                $fenixZipError.show();

            }
        }
        function attachAllFenixEventHandlers(){
            if(!fenixEventHandlersAttached){
                $(document).on('click', '#fenix-toggle-zip', toggleZipField)
                $(document).on('click', '#check-zip', getEstimateForZip);
                $(document).on('keypress', '#zip-inpt', function(e){
                    if(e.which === 13 || e.keyCode === 13){
                        e.preventDefault();
                        e.stopPropagation();
                        getEstimateForZip();

                    }
                });

                $(document).on('click','#fenix_submit', function() {
                    $productFormStatus.removeAttr("style");
                });
                if(fenixStoreInfo && fenixStoreInfo.inventoryAvailable) {
                    $(document).on('change', "[name=quantity]", function(e){
                        checkShippingEstimate();
                    });
                }
                fenixEventHandlersAttached = true;
            }
        }
        function productTagAddProcessing(prop){
            if(prop && prop.type === 'productTag' && prop.value && fenixFixdDelivery.product){
                let prodTags = fenixFixdDelivery.product.tags;
                if(prodTags.indexOf(prop.value) > -1){
                    fenixAdditionalProcessing = true;
                }
            }
        }
        function formFieldAdditionalProcessing(prop){
            if(prop && prop.type === 'formField' && prop.name && prop.value){
                let productForm = $('form[action="/cart/add"]');
                let formArray = $('form[action="/cart/add"]').serializeArray();
                let formElem = $(`[name="${prop.name}"]`);
                if(formElem && formElem.val() === prop.value){
                    fenixAdditionalProcessing = true;
                    if(prop.name !== 'properties[_fenixAdditionalProcessing]' && $(productForm).find('[name="properties[_fenixAdditionalProcessing]"]').length < 1){
                        $(productForm).append('<input type="hidden" name="properties[_fenixAdditionalProcessing]" value=true />');
                    }
                    $(formElem).on('change', function(){
                        if($(this).val() === prop.value && fenixAdditionalProcessing === false){
                            fenixAdditionalProcessing = true;
                            if($(this).attr('name') !== 'properties[_fenixAdditionalProcessing]') {
                                $(productForm).find('[name="properties[_fenixAdditionalProcessing]"]').val(true);
                            }
                            checkShippingEstimate();
                        } else if (fenixAdditionalProcessing === true){
                            fenixAdditionalProcessing = false;
                            if($(this).attr('name') !== 'properties[_fenixAdditionalProcessing]') {
                                $(productForm).find('[name="properties[_fenixAdditionalProcessing]"]').val(false);
                            }
                            checkShippingEstimate();
                        }
                    });
                }
            }
        }
        function getNewShippingEstimatesOnChange(){
            try{
                if(fenixFixdDelivery && fenixFixdDelivery.hasOwnProperty('getShippingEstimatesOnChange') && fenixFixdDelivery['getShippingEstimatesOnChange'].hasOwnProperty('length')) {
                    let changeFields = fenixFixdDelivery['getShippingEstimatesOnChange'];
                    if(changeFields && changeFields.length > 0) {
                        for(let fIndx=0; fIndx < changeFields.length; fIndx++) {
                            let field = changeFields[fIndx];
                            if(field && field['tag'] && field['name']){
                                let selector = `${field['tag']}[name="${field['name']}"]`;
                                let eventName = (field['type'] && (field['type'] === 'text' || field['type'])) === 'number' ? 'input' : 'change';
                                $(selector).on(`${eventName}`, function(event){
                                    let fenixGetEstimateTimer = setTimeout(function() {
                                        let formElement = $('form[action="/cart/add"]');
                                        let formVal = $('form[action="/cart/add"]').serializeArray();
                                        let variantId = '';
                                        formVal.findIndex(function(val){
                                            if(val.name && val.name ==='id'){
                                                variantId = val.value;
                                                return true;
                                            }
                                        });
                                        if(formVal && formVal.length > 0 && variantId) {
                                            let selVariantIndx = fenixFixdDelivery.product.variants.findIndex(function(variant){
                                                if(variant.id === parseInt(variantId)){
                                                    return true;
                                                }
                                            });
                                            if(selVariantIndx > -1){
                                                let selectedVariant = fenixFixdDelivery.product.variants[selVariantIndx];
                                                sku = selectedVariant.sku;
                                                price = selectedVariant.price;
                                                fenixFixdDelivery.productVariant = selectedVariant;
                                                variantid = selectedVariant.id;
                                                availableqty = selectedVariant.inventory_quantity || 1;
                                                flag = selectedVariant.available;
                                                physical = selectedVariant.requires_shipping;
                                                checkShippingEstimate();
                                            }

                                        }
                                    }, 300);
                                });
                            }
                        }
                    }
                }
            }catch(err){
                console.log('Unable to fetch Fenix FIXD Delivery Estimates on option change');
            }
        }
        function checkAdditionalProcessing(){
            if(fenixFixdDelivery && fenixFixdDelivery.hasOwnProperty('additionalProcessing') && typeof fenixFixdDelivery['additionalProcessing'] === 'object' && fenixFixdDelivery['additionalProcessing'].hasOwnProperty('length')){
                let addProps = fenixFixdDelivery['additionalProcessing'];
                let fenixAddProcessingIndx = addProps.findIndex(function(elem){
                    if(elem && elem['name'] && elem['name'] === 'properties[_fenixAdditionalProcessing]') {
                        return true;
                    }
                });
                if(fenixAddProcessingIndx > -1){
                    formFieldAdditionalProcessing(addProps[fenixAddProcessingIndx]);
                }else{
                    for(let aIndx=0; aIndx < addProps.length; aIndx++){
                        let prop = addProps[aIndx];
                        if(prop && prop.type){
                            switch (prop.type){
                                case 'productTag':
                                    productTagAddProcessing(prop);
                                    break;
                                case 'formField':
                                    formFieldAdditionalProcessing(prop);
                                    break;
                            }
                        }
                    }
                }
            }
        }
        function getLocation() {
            let ipLocation = '';
            const GoogleKey = "AIzaSyA4d5hOMddDPW4dx9W6z-BI3aAX32fcZYo";
            const GoogleUrl = "https://maps.googleapis.com/maps/api/geocode/json?latlng=";
            function Set_Cookie(name, value, path) {
                let today = new Date();
                let zero_date = new Date(0, 0, 0);
                today.setTime(today.getTime() - zero_date.getTime());
                let cookie_expire_date = new Date(today.getTime() + (8 * 7 * 86400000));
                if (name.includes('ssid')) {
                    value = btoa(value)
                }
                let cookieString = name + "=" + value + (";expires=" + cookie_expire_date.toGMTString()) + ((path) ? ";path=" + path : "");
                document.cookie = cookieString;
            }

            function geoSuccess(position) {
                const lat = position.coords.latitude;
                const lng = position.coords.longitude;
                $.get(`${GoogleUrl}${lat},${lng}&result_type=postal_code&key=${GoogleKey}`).done((location) => {
                    ipLocation = location.results[0].address_components[0].short_name;
                    zipcode = ipLocation;
                    flag = !0;
                    if (isValidUSZip(zipcode)) {
                        Cookies.set('location', zipcode, {
                            path: '/'
                        });
                        checkShippingEstimate()
                    }
                }).fail((error) => {
                    Cookies.set('location', '', {
                        path: '/'
                    })
                })
            }

            function geoError(error) {
                switch (error.code) {
                    case error.PERMISSION_DENIED:
                        break;
                    case error.POSITION_UNAVAILABLE:
                        break;
                    case error.TIMEOUT:
                        break;
                    case error.UNKNOWN_ERROR:
                        break
                }
                flag = !0;
                $toggleZip.text("Enter Zip");
                $toggleZip.show()
            }
			function geoLocationSuccess(geoZipcode){
                zipcode = geoZipcode;
                flag = !0;
                if (isValidUSZip(zipcode)) {
                    Cookies.set('location', zipcode, {
                        path: '/'
                    });
                    checkShippingEstimate();
                }
            }
            if (typeof Cookies.get("location") === 'undefined') {
                ipLookUp()
            } else {}

            function ipLookUp() {
				getPositionCoordinates(geoLocationSuccess);
//                 $.ajax('https://ipapi.co/json').then(function success(response) {
//                     ipLocation = response.postal;
//                     Set_Cookie("location", ipLocation, "/");
//                     zipcode = ipLocation;
//                     if (isValidUSZip(zipcode)) {
//                         checkShippingEstimate()
//                     }
//                 }, function fail(data, status) {
//                     navigator.geolocation.getCurrentPosition(geoSuccess, geoError, {
//                         timeout: 20000
//                     })
//                 })
            }

            let ssid = '';
            if (Cookies.get('__ssid') != null) {
                ssid = Cookies.get('__ssid');
                if (!ssid) {
                    ssid = ''
                }
            } else {
                Set_Cookie("__ssid", Math.random(), "/")
            }
        }
    };
    let fenix_cart_estimates = function($){
        let ssid = Cookies.get('__ssid') != null ? Cookies.get('__ssid') : '';
        const $fenixResponse = $('.fenix-fixd-delivery-cart');
        if(fenixFixdDelivery && !fenixFixdDelivery.itemLevelEstimate){
            $($fenixResponse).not('[data-sku]').wrap(`<div class='fenix-fixd-cart-response' style="display: none;"></div>`);
            let parentResponseElement = $('.fenix-fixd-cart-response');
            const toggleZipTemplate = `<div id="fenix-zip" style="display: none;">
                <input type='text' id='zip-inpt'/><button type='button' id='check-zip'>Check Delivery</button></div><div class='zip-input-error' >Unable to get estimated delivery date. <span class='validation-error' style="display: none;">Please enter a valid US zipcode</span></div>`;
            if(parentResponseElement && parentResponseElement.length > 0){
                for(let eIndx=0; eIndx < parentResponseElement.length; eIndx++){
                    let elem = parentResponseElement[eIndx];
                    $(elem).append(`<div id="fenix-change-zip" ><a id="fenix-toggle-zip" class="update-zip" style="display: none;">Change ZIP</a>${toggleZipTemplate}</div>`);
                }
            }
        }
        document.dispatchEvent(fenixInitializedEvent);
        let $zipDiv = $('#fenix-zip');
        let $zipInpt = $('#zip-inpt');
        let $checkZip = $('#check-zip');
        let $toggleZip = $('#fenix-toggle-zip');
        let $fenixZipElement = $('#fenix-change-zip');
        let $fenixZipError = $('#fenix-change-zip .zip-input-error');
        let $fenixValidationError = $('#fenix-change-zip .zip-input-error .validation-error');
//     In shopify preview pages, SSID is unavailable
//     let ssid = Cookies.get('__ssid') != null ? document.cookie.split('; __ssid=')[1].split('; ')[0] : '';
//     function isValidUSZip(sZip) {
//         return /^\d{5}(-\d{4})?$/.test(sZip);

//     }
        let $zipcode = Cookies.get("location") != null && isValidUSZip(Cookies.get("location")) ? Cookies.get("location") : '';

        if ($zipcode && fenixFixdDelivery) {
            checkShippingEstimate();
        }
        function checkShippingEstimate() {
            let cartLength = 0;
            let items = [], totalPrice = 0, cartAdditionalProcessing = false;
            if(typeof fenixFixdDelivery !== 'undefined' && fenixFixdDelivery && fenixFixdDelivery.cartItems && fenixFixdDelivery.cartItems.length){
                cartLength = fenixFixdDelivery.cartItems.length;
            }
            for (let i=0; i<cartLength; i++) {
                if (fenixFixdDelivery.itemLevelEstimate) {
                    const item = fenixFixdDelivery.cartItems[i];
                    const price = item.price,
                        sku = item.sku,
                        availableQty = item.variant && item.variant.inventory_quantity ? item.variant.inventory_quantity : item.quantity,
                        locationId = item.fulfillment_service || 'manual',
                        orderQty = item.quantity,
                        physical = item.requires_shipping,
                        itemAdditionalProcessing = checkAdditionalProcessing(item);

                    if (physical || physical === 'true') {
                        function getRequestData() {
                            let reqObj = {
                                "sessionTrackId": ssid,
                                "buyerZipCode": "" + $zipcode,
                                "monetaryValue": parseInt(price),
                                "pageType": 'cart',
                                "responseFormat": "json",
                                "skus": [{
                                    "quantity": parseInt(orderQty) || 1,
                                    "sku": sku,
                                    "skuInventories": [{
                                        "locationId": locationId,
                                        "quantity": availableQty <= 0 ? 1 : parseInt(availableQty),
                                    }]
                                }]
                            };
                            if(itemAdditionalProcessing){
                                reqObj['additionalProcessing'] = true;
                            }
                            return reqObj;
                        }

                        $.ajax({
                            type: "POST",
                            url: fenixStoreInfo.delEstUrl,
                            data: JSON.stringify(getRequestData()),
                            headers: {
                                'tenantId': $tenantId, // Fenix Tenant ID - Will be shared by Fenix team
                                'Content-Type': 'application/json'
                            },
                            dataType: "json"
                        })
                            .done(function(data) {
                                var res = data[0];
                                var phrase = '';
                                if(fenixFixdDelivery.createPhraseForDeliveryEstimate && typeof fenixFixdDelivery.createPhraseForDeliveryEstimate === 'function'){
                                    phrase = fenixFixdDelivery.createPhraseForDeliveryEstimate(res, 'cart');
                                } else {
                                    phrase = createPhraseForDeliveryEstimate(res, 'cart');
                                }
                                $fenixResponse.each((i,element) => {
                                    if ($(element).data('sku') && $(element).data('sku').trim() === res.webId) {
                                        $(element).html( phrase );
//                                       	showChangeZipInCart(element, phrase);
                                        $(element).attr('data-fenix-session', ssid);
                                    }
                                });
                            })
                            .fail(function(error) {
                                $fenixResponse.each((i,element) => {
                                    if ($(element).data('sku') && $(element).data('sku').trim() === res.webId) {
                                        $(element).html( '' );
                                    }
                                });
                            });
                    }
                } else {
                    const item = fenixFixdDelivery.cartItems[i];
                    const price = item.price,
                        sku = item.sku,
                        availableQty = item.variant && item.variant.inventory_quantity ? item.variant.inventory_quantity : item.quantity,
                        locationId = item.fulfillment_service || 'manual',
                        orderQty = item.quantity || 1,
                        physical = item.requires_shipping,
                        itemAdditionalProcessing = (!cartAdditionalProcessing)?checkAdditionalProcessing(item):cartAdditionalProcessing;
                    if (physical || physical === 'true') {
                        totalPrice += parseInt(price);
                        let reqItemObj = {
                            "quantity": parseInt(orderQty) || 1,
                            "sku": sku,
                            "skuInventories": [{
                                "locationId": locationId,
                                "quantity": availableQty <= 0 ? 1 : parseInt(availableQty),
                            }]
                        };
                        if(itemAdditionalProcessing && !cartAdditionalProcessing){
                            cartAdditionalProcessing = true;
                        }
                        items.push(reqItemObj);
                    }
                }
            };
            if (!fenixFixdDelivery.itemLevelEstimate) {
                let reqObj = {
                    "sessionTrackId": ssid,
                    "buyerZipCode": "" + $zipcode,
                    "monetaryValue": parseInt(totalPrice),
                    "pageType": 'cart',
                    "responseFormat": "json",
                    "skus": items
                };
                if(cartAdditionalProcessing) {
                    reqObj['additionalProcessing'] = true;
                }
                $.ajax({
                    type: "POST",
                    url: fenixStoreInfo.delEstUrl,
                    data: JSON.stringify(reqObj),
                    headers: {
                        'tenantId': $tenantId, // Fenix Tenant ID - Will be shared by Fenix team
                        'Content-Type': 'application/json'
                    },
                    dataType: "json"
                })
                    .done(function(data) {
                        var res = data[0];
                        var phrase = '';
                        if(fenixFixdDelivery.createPhraseForDeliveryEstimate && typeof fenixFixdDelivery.createPhraseForDeliveryEstimate === 'function'){
                            phrase = fenixFixdDelivery.createPhraseForDeliveryEstimate(res, 'cart');
                        } else {
                            phrase = createPhraseForDeliveryEstimate(res, 'cart');
                        }
                        let elem = $('.fenix-fixd-delivery-cart:not([data-sku])');
                        $(elem).html( phrase );
                        showChangeZipInCart(elem, phrase);
                        $fenixZipError.hide();
                        $fenixValidationError.hide();
                        $('.fenix-fixd-cart-response').show();
                        $(elem).attr('data-fenix-session', ssid);
                    })
                    .fail(function(error) {
                        let elem = $('.fenix-fixd-delivery-cart:not([data-sku])');
                        $(elem).html( '' );
                        if(fenixFixdDelivery && !fenixFixdDelivery.itemLevelEstimate && !fenixCartEventHandlersAttached){
                            $('.fenix-fixd-cart-response').hide();
                        } else {
                            $fenixZipError.show();
                        }
                    });
            }
            function checkAdditionalProcessing(item){
                let reqAddProcess = false;
                if(item && item.properties && item.properties['_fenixAdditionalProcessing']){
                    reqAddProcess = true;
                }
//           	if(fenixFixdDelivery && fenixFixdDelivery.hasOwnProperty('additionalProcessing') && typeof fenixFixdDelivery['additionalProcessing'] === 'object' && fenixFixdDelivery['additionalProcessing'].hasOwnProperty('length')){
//               for(let aIndx=0; aIndx < fenixFixdDelivery.additionalProcessing.length; aIndx++){
//               	let processParam = fenixFixdDelivery.additionalProcessing[aIndx];
//                 if(processParam['lineItemKey'] && item[processParam['lineItemKey']] && processParam['value']){
//                 	let field = item[processParam['lineItemKey']];
//                   if(processParam.hasOwnProperty('name') && processParam['name'] && field[processParam['name']] && field[processParam['name']] === processParam['value']){
//                   	reqAddProcess = true;
//                   } else if(item[processParam['lineItemKey']] === processParam['value']){
//                   	reqAddProcess = true;
//                   }
//                 }
//               }
//             }
                return reqAddProcess;
            }
        }
        function getEstimateForZip(e){
            if(e) {
                e.stopPropagation();
            }
            if (isValidUSZip($zipInpt.val())) {
                let zipcode = $zipInpt.val();
                Cookies.remove('location', {
                    path: '/'
                });
                Cookies.set('location', zipcode, {
                    path: '/'
                });
                $zipcode = zipcode;
                checkShippingEstimate();
                $toggleZip.show();
                $zipDiv.hide();
                $fenixZipError.hide();
                $fenixValidationError.hide();
            } else {
                //                 $fenixResponse.hide();
                //                 $toggleZip.hide();
                //                 $zipDiv.show();
                $fenixZipError.show();
                $fenixValidationError.show();

            }
        }
        function attachFenixCartEventHandlers(){
            if(!fenixCartEventHandlersAttached){
                $(document).on('click', '#fenix-toggle-zip', function(e) {
                    if(e){
                        e.stopPropagation();
                    }
                    $toggleZip.hide();
                    $zipDiv.show();
                });
                $(document).on('click', '#check-zip', getEstimateForZip);
                $(document).on('keypress', '#zip-inpt', function(e){
                    if(e.which === 13 || e.keyCode === 13){
                        e.preventDefault();
                        e.stopPropagation();
                        getEstimateForZip();
                    }
                });
                fenixCartEventHandlersAttached = true;
            }
        }
        function showChangeZipInCart(element, phrase) {
            if(fenixFixdDelivery && fenixFixdDelivery.showChangeZip && element && !fenixFixdDelivery.itemLevelEstimate){
                let zipElement = $(element).parent().find('#fenix-change-zip');
                //           	 const $currzipDiv = $(zipElement).find('#fenix-zip');
                //              const $currzipInpt = $(zipElement).find('#zip-inpt');
                //              const $currcheckZip = $(zipElement).find('#check-zip');
                //              const $currtoggleZip = $(zipElement).find('#fenix-toggle-zip');
                //              const $currfenixZipError = $(zipElement).find('.zip-input-error');
                if(phrase && phrase.length > 0){
                    $toggleZip.show();
                    $zipDiv.hide();
                    $fenixZipError.hide();
                }else {
                    if(!fenixCartEventHandlersAttached){
                        $toggleZip.attr('style', 'display: none !important');
                    } else {
                        $fenixZipError.show();
                    }
                    //                     $toggleZip.show();
                    //                     $fenixZipError.show();
                }
                if(!fenixCartEventHandlersAttached){
                    attachFenixCartEventHandlers();
                }
            }
        }
    };
    let loadScript = function(url, callback){

        let script = document.createElement("script");
        script.type = "text/javascript";

        // If the browser is Internet Explorer.
        if (script.readyState){
            script.onreadystatechange = function(){
                if (script.readyState == "loaded" || script.readyState == "complete"){
                    script.onreadystatechange = null;
                    callback();
                }
            };
            // For any other browser.
        } else {
            script.onload = function(){
                callback();
            };
        }

        script.src = url;
        document.getElementsByTagName("head")[0].appendChild(script);

    };
    // let fenix_cart_script = function(){
    //     if (typeof cartJSObject !== 'undefined' && cartJSObject && Object.keys(cartJSObject).length > 0) {
    //         let scriptElem = document.createElement("script");
    //         let scriptContent = `jQuery(function() {
	// 	CartJS.init(
	// 	${JSON.stringify(cartJSObject.cart)},
	// 	{
    //     currency: ${JSON.stringify(cartJSObject.shop.currency)},
    //     moneyFormat: ${JSON.stringify(cartJSObject.shop.moneyFormat)},
    //     moneyWithCurrencyFormat: ${JSON.stringify(cartJSObject.shop.moneyWithCurrencyFormat)},
    //     rivetsModels: {
    //       shipping: {
    //         is_submitting: false,
    //         has_rates: false,
    //         has_errors: false,
    //         errors: [],
    //         rates: [],
    //         first_price: 0
    //       }
    //     }
    //   });
    //   });`;
    //         scriptElem.appendChild(document.createTextNode(scriptContent));
    //         document.body.appendChild(scriptElem);
    //     }
    // };
    var hideFenixProperties = function (){
        $('.cart__meta-text').each(function() {
            var $this = $(this);
            $this.html($this.text().replace(/_fenixAdditionalProcessing:\s*(true|false)*/gi, function(match, grp1){
                return `<span style="display:none;">${match}</span>`;
            }));
        });
    }

    var getFixdDeliveryEstimates = function($){
        try {
          getPositionCoordinates();
            if(typeof fenixFixdDelivery !== 'undefined' && fenixFixdDelivery && Object.keys(fenixFixdDelivery).length > 0 && fenixFixdDelivery.template && (fenixFixdDelivery.template.toLowerCase().indexOf('product') > -1 ||fenixFixdDelivery.template.toLowerCase().indexOf('cart') > -1) ){
                addFixdDeliveryCss(fenixFixdDelivery.fenixMessageStyles);
                // fenix_cart_script();
                setupFenixEvents();
                if(fenixFixdDelivery && fenixFixdDelivery.page === 'product'){
                    fenix_pdp_estimates($);
                } else {
                    hideFenixProperties();
                    fenix_cart_estimates($);
                }
            }else{
                ++retryAttempts;
                if(retryAttempts < 10){
                    setTimeout(function(){
                        getFixdDeliveryEstimates($);
                    }, 300);
                }
            }
        }catch(err){
            console.log('Unable to fetch Fenix FIXD Delivery Estimates');
        }
    }
    var getStoreInfo = function($){
        let storeFetchUrl = 'https://delest-api.fenixcommerce.com/fenixdelest/api/v1/';
        var storeNamePattern = new RegExp(".myshopify.com");
        if(Shopify && Shopify.shop){
            storeFetchUrl += Shopify.shop + '/storeinfo';
        } else if (fenixFixdDelivery && fenixFixdDelivery.shop){
            storeFetchUrl += fenixFixdDelivery.shop + '/storeinfo';
        }
        if(storeNamePattern.test(storeFetchUrl)){
          let _fenixStoreInfo = window.sessionStorage.getItem('_fenixStoreInfo');
            if(_fenixStoreInfo && JSON.parse(_fenixStoreInfo) && JSON.parse(_fenixStoreInfo).tenantId){
                let storeData = JSON.parse(_fenixStoreInfo);
                $tenantId = storeData.tenantId;
                fenixStoreInfo = storeData;
                getFixdDeliveryEstimates($);
            }else {
              $.ajax({
                  type: "GET",
                  url: storeFetchUrl,
                  cache: true,
                  dataType: "json"
              })
                .done(function(data) {
                    if(data && data.tenantId){
                      	window.sessionStorage.setItem('_fenixStoreInfo', JSON.stringify(data));
                        $tenantId = data.tenantId;
                        fenixStoreInfo = data;
                        getFixdDeliveryEstimates($);
                    }
                })
                .fail(function(error) {

                });
            }
        }

    };
    if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7)) {
        loadScript('//ajax.googleapis.com/ajax/libs/jquery/3.0.0/jquery.min.js', function(){
            jQuery300 = jQuery.noConflict(true);
            getStoreInfo(jQuery300);
        });
    } else {
        getStoreInfo(jQuery);
    }
})();
